var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_3739",
    "data-name": "Groupe 3739",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.849,
    height: 17.983,
    viewBox: "0 0 17.849 17.983",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3640",
    "data-name": "Rectangle 3640",
    width: 17.849,
    height: 17.983,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3705",
    "data-name": "Groupe 3705",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3704",
    "data-name": "Groupe 3704",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3703",
    "data-name": "Groupe 3703",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3702",
    "data-name": "Groupe 3702",
    opacity: 0.8,
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3701",
    "data-name": "Groupe 3701"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3700",
    "data-name": "Groupe 3700",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2362",
    "data-name": "Trac\\xE9 2362",
    d: "M14.957,11.327a.686.686,0,0,1-.686.686H5.227a1.444,1.444,0,0,0-.914.324L2.888,13.5V3.573a.686.686,0,0,1,.686-.686h10.7a.686.686,0,0,1,.686.686ZM11.6,0H3.576A3.579,3.579,0,0,0,0,3.575V16.538a1.447,1.447,0,0,0,2.359,1.121l3.383-2.753h8.531a3.58,3.58,0,0,0,3.576-3.576V8.6l0-2.894V3.573A3.58,3.58,0,0,0,14.491,0Z",
    transform: "translate(0 0)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/messageIcon.682029639ef033db9143ad09c7e2ba89.svg";
export { ForwardRef as ReactComponent };